import { Box } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../src/components/common/Breadcrumbs";
import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import { LendingPartnersDetails } from "../src/modules/LendingPartners";
import { sendAnalytics } from "../src/utils/analyticsCommon";

const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Lending Partners" },
];

const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Lending Partners",
      item: "https://www.turno.club/lending-partners",
    },
  ],
};

export default function LendingPartners() {
  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "lending-partners" }, "en");
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Head>
        <title>Lending Partners</title>
        <meta
          name="description"
          content="Get a commercial electric three-wheeler from Turno and get the best price options and loan/financing for your electric load gadi from our lending partners."
        />
        <meta
          name="keywords"
          content="Turno, Lending Partners,  Electric Three Wheeler, electric commercial vehicle price, 3 wheeler loading auto, electric goods vehicle, 3 wheeler, mahindra ev, piaggio price, etrio, osm"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/lending-partners" />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.turno.club/lending-partners" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>
      <MemoizedHeader />

      <LendingPartnersDetails />
      <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
        <Breadcrumbs items={BREADCRUMB_ITEMS} />
      </Box>
      <MemoizedFooter />
    </>
  );
}
